// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"132":"459a7a6c","247":"291e0fd9"}[chunkId] + ".chunk.css";
};